import { MessageCircle, ClipboardList, Printer, PackageCheck } from "lucide-react";
import Reveal from "@/components/Reveal";

const STEPS = [
    {
        n: "01",
        icon: MessageCircle,
        title: "Conte sua ideia",
        desc: "Manda sua referência ou arquivo (.STL, .3MF) pelo WhatsApp ou e-mail.",
    },
    {
        n: "02",
        icon: ClipboardList,
        title: "Orçamento e material",
        desc: "Indicamos material, cor e prazo. Você aprova antes de começar.",
    },
    {
        n: "03",
        icon: Printer,
        title: "Impressão",
        desc: "Sua peça ganha volume camada por camada na bancada da forja.",
    },
    {
        n: "04",
        icon: PackageCheck,
        title: "Entrega",
        desc: "Acabamento, inspeção final e envio ou retirada.",
    },
];

export const ComoPedir = () => (
    <section id="como-pedir" className="border-y border-forge-line bg-forge-panel/40 py-24 md:py-32" data-testid="how-section">
        <div className="zf-container">
            <Reveal>
                <p className="zf-eyebrow">Como pedir</p>
                <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold uppercase leading-tight text-forge-paper md:text-5xl">
                    Da ideia à peça em 4 passos
                </h2>
            </Reveal>

            <div className="relative mt-16">
                <div className="absolute left-[12%] right-[12%] top-8 hidden border-t border-dashed border-forge-line md:block" aria-hidden />
                <div className="grid gap-10 md:grid-cols-4 md:gap-8">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={0.08 * i}>
                            <div className="group relative" data-testid="how-step">
                                <div className="relative z-10 inline-flex h-16 w-16 items-center justify-center border border-forge-line bg-forge-ink text-forge-yellow transition-colors duration-300 group-hover:border-forge-yellow">
                                    <s.icon className="h-6 w-6" />
                                    <span className="absolute -right-2 -top-2 bg-forge-yellow px-1.5 py-0.5 font-mono text-[10px] font-bold text-forge-ink">
                                        {s.n}
                                    </span>
                                </div>
                                <h3 className="mt-5 font-display text-base font-bold uppercase text-forge-paper">{s.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-forge-dim">{s.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default ComoPedir;
